import Model, { attr, belongsTo } from '@ember-data/model';
import type CompanyModel from './company.ts';
import type EmailTemplateModel from 'tio-common/models/email-template';
import { Type } from '@warp-drive/core-types/symbols';
import { type OutputData } from '@editorjs/editorjs';
export default class CustomCompanyEmailTemplateModel extends Model {
  @attr declare name: string;
  @attr declare subject: string;
  @attr declare editorJsData: OutputData;
  @attr declare isActive: boolean;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('company', { async: false, inverse: 'customCompanyEmailTemplates' })
  declare company: CompanyModel;
  @belongsTo('email-template', { async: false, inverse: 'customCompanyEmailTemplates' })
  declare emailTemplate: EmailTemplateModel;

  [Type] = 'custom-company-email-template' as const;
}
